import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$2 = ".RecoveryCodeSaveScreen_module_codes__5283da32{column-gap:4ch;display:grid;grid-template-columns:repeat(auto-fill,var(--st-max-code-length));justify-content:center;list-style:none;margin:0 auto;max-width:calc(var(--st-max-code-length)*2 + 4ch)}.RecoveryCodeSaveScreen_module_codes__5283da32 li{-webkit-user-select:all;user-select:all;white-space:nowrap}";
collectCss(css$2);
var modules_18162161 = {"codes":"RecoveryCodeSaveScreen_module_codes__5283da32"};

export { css$2 as css, modules_18162161 as default };
//# sourceMappingURL=RecoveryCodeSaveScreen.module.css.mjs.map
